import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Mail, Phone, MapPin, Send, Facebook, Instagram, MessageCircle } from "lucide-react";

const CTAFooter = () => {
  const [scrollY, setScrollY] = useState(0);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    childAge: '',
    message: ''
  });

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Scroll effect for CTA banner
  const getCTABannerStyles = () => {
    const sectionStart = 4000; // Approximate start of CTA section
    const fadeStart = sectionStart;
    const fadeEnd = sectionStart + 400;
    
    let opacity = 0.3;
    let transform = 'translateY(40px)';
    
    if (scrollY > fadeStart) {
      if (scrollY <= fadeEnd) {
        const fadeProgress = (scrollY - fadeStart) / (fadeEnd - fadeStart);
        opacity = 0.3 + (fadeProgress * 0.7); // Fade from 0.3 to 1
        transform = `translateY(${40 - (fadeProgress * 40)}px)`; // Move from 40px to 0px
      } else {
        opacity = 1;
        transform = 'translateY(0px)';
      }
    }
    
    return { opacity, transform };
  };

  //Codigo para el form

  const handleInputChange = (e) => { setFormData({ ...formData, [e.target.name]: e.target.value }); }; 
  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!formData.name || !formData.email || !formData.childAge) {
      alert('Por favor completa todos los campos requeridos.');
      return;
    }

    // Format WhatsApp message
    const whatsappMessage = `¡Hola! Me interesa información sobre Laboratorio Secreto.

📋 *Información de contacto:*
• Nombre: ${formData.name}
• Email: ${formData.email}
• Teléfono: ${formData.phone || 'No proporcionado'}
• Edad del niño: ${formData.childAge} años

${formData.message ? `💭 *Mensaje adicional:*\n${formData.message}` : ''}

¡Esperamos su respuesta para agendar una clase de prueba!`;

    // WhatsApp number (remove spaces and special characters)
    const whatsappNumber = '15551234567'; // +1 (555) 123-4567
    
    // Create WhatsApp URL
    const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;
    
    // Open WhatsApp in new tab
    window.open(whatsappURL, '_blank');
    
    // Clear form after successful submission
    setFormData({
      name: '',
      email: '',
      phone: '',
      childAge: '',
      message: ''
    });
    
    // Show success message
    alert('¡Perfecto! Te estamos redirigiendo a WhatsApp para completar tu solicitud.');
  };


  const faqs = [
    {
      question: "¿Qué edad debe tener mi hijo?",
      answer: "Nuestros programas están diseñados para niños de 6 a 14 años."
    },
    {
      question: "¿Necesita experiencia previa?", 
      answer: "No, empezamos desde cero y adaptamos el contenido al nivel de cada estudiante."
    },
    {
      question: "¿Las clases son individuales o grupales?",
      answer: "Ofrecemos ambas modalidades. Los grupos tienen máximo 6 estudiantes."
    }
  ];

  // Custom TikTok icon component
  const TikTokIcon = ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-.88-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z" fill="currentColor"/>
    </svg>
  );

  const ctaBannerStyles = getCTABannerStyles();

  return (
    <footer className="cta-footer">
      <div 
        className="cta-banner"
        style={{
          opacity: ctaBannerStyles.opacity,
          transform: ctaBannerStyles.transform,
          transition: 'opacity 0.8s ease-out, transform 0.8s ease-out'
        }}
      >
        <div className="section-container">
          <div className="cta-content">
          <h2 className="cta-title">
            Es hora de que tu hijo 
           <span className="title-highlight"> entre al laboratorio</span>
          </h2>

          <p className="cta-subtitle">
            Únete a cientos de familias que ya están preparando a sus hijos para el futuro.
          </p>

          <a
            href="https://wa.me/525572269158?text=Hola%20quiero%20reservar%20una%20clase%20de%20prueba%20GRATIS%20para%20mi%20hijo"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary-large"
            onClick={() => {
              window.fbq?.("track", "Contact");
              console.log("Click WhatsApp CTA");
            }}
          >
            <span>Reserva tu clase de prueba</span>
            <ArrowRight className="btn-icon" />
          </a>

          </div>
          <div className="cta-glow"></div>
        </div>
      </div>

      <div className="footer-content">
        <div className="section-container">
          <div className="footer-grid">
            <div className="contact-section">
              <h3 className="footer-section-title">Contacto</h3>
              <div className="contact-info">
                <div className="contact-item">
                  <Mail className="contact-icon" />
                  <span>aprendeconjenn@gmail.com</span>
                </div>
                <div className="contact-item">
                  <Phone className="contact-icon" />
                  <span>+52 (55) 72269158</span>
                </div>
                <div className="contact-item">
                  <MapPin className="contact-icon" />
                  <span>100% Online</span>
                </div>
              </div>
              
              {/* Social Media Links */}
              <div className="social-media">
                <h4 className="social-title">Síguenos</h4>
                <div className="social-links">
                  <a href="https://wa.me/525572269158" className="social-link" aria-label="WhatsApp">
                    <MessageCircle className="social-icon" />
                  </a>
                  <a href="https://www.tiktok.com/@edukidsmx?_r=1&_t=ZS-92AvL1BsQfH" className="social-link" aria-label="TikTok">
                    <TikTokIcon className="social-icon" />
                  </a>
                  <a href="https://www.instagram.com/labsecreto.academy/" className="social-link" aria-label="Instagram">
                    <Instagram className="social-icon" />
                  </a>
                  <a href="https://www.facebook.com/people/Edukids/61570075405041/?mibextid=wwXIfr&rdid=BwtMaRd0MwRiY7K1&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1D12fVsjLe%2F%3Fmibextid%3DwwXIfr%26ref%3D1" className="social-link" aria-label="Facebook">
                    <Facebook className="social-icon" />
                  </a>
                </div>
              </div>
            </div>

            <div className="form-section">
              <h3 className="footer-section-title">Solicita Información</h3>
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-row">
                  <input
                    type="text"
                    name="name"
                    placeholder="Nombre del padre/madre"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="form-input"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="form-input"
                  />
                </div>
                <div className="form-row">
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Teléfono"
                    value={formData.phone}
                    onChange={handleInputChange}
                    className="form-input"
                  />
                  <input
                    type="number"
                    name="childAge"
                    placeholder="Edad del niño"
                    min="6"
                    max="14"
                    value={formData.childAge}
                    onChange={handleInputChange}
                    required
                    className="form-input"
                  />
                </div>
                <textarea
                  name="message"
                  placeholder="¿En qué programa está más interesado tu hijo?"
                  value={formData.message}
                  onChange={handleInputChange}
                  rows="3"
                  className="form-textarea"
                ></textarea>
                <button type="submit" className="form-submit">
                  <Send className="btn-icon" />
                  <span>Enviar solicitud</span>
                </button>
              </form>
            </div>

            <div className="faq-section">
              <h3 className="footer-section-title">Preguntas Frecuentes</h3>
              <div className="faq-list">
                {faqs.map((faq, index) => (
                  <div key={index} className="faq-item">
                    <h4 className="faq-question">{faq.question}</h4>
                    <p className="faq-answer">{faq.answer}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="footer-brand">
              <span className="footer-logo">Laboratorio Secreto</span>
              <span className="footer-tagline">Donde el futuro comienza</span>
            </div>
            <div className="footer-legal">
              <span>© 2024 Laboratorio Secreto. Todos los derechos reservados.</span>
              <span className="footer-sep" aria-hidden="true">·</span>
              <Link
                to="/politicas"
                className="footer-link"
                data-testid="footer-policies-link"
              >
                Políticas
              </Link>
              <span className="footer-sep" aria-hidden="true">·</span>
              <Link
                to="/login-profesoras"
                className="footer-link footer-link-muted"
                data-testid="footer-login-link"
              >
                Acceso profesoras
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default CTAFooter;